module.exports = __webpack_public_path__ + "img/needle-right3.3a75b598.png";